import { useState } from 'react';
import Dialog from './Dialog';
import { Text } from '../general/Text';
import { en } from '../../locales/en';
import { AsyncAction } from '../../types/general/asyncAction';
import { useGcsStore } from '../../store/useGcsStore';
import type { VehicleId } from '../../types/gcs/vehicle';
import type { MissionId } from '../../types/gcs/mission';
import { useLocalizedErrorMessage } from '../../hooks/useLocalizedErrorMessage';
import { getShortVehicleId } from '../../utils/formatters';

interface ConfirmRtlDialogProps {
  gcsId: string;
  vehicleId: VehicleId;
  missionId: MissionId;
  onClose: () => void;
}

function ConfirmRtlDialog({ gcsId, vehicleId, missionId, onClose }: ConfirmRtlDialogProps) {
  const getLocalizedErrorMessage = useLocalizedErrorMessage();
  const [rtlAction, setRtlAction] = useState<AsyncAction>(AsyncAction.initial());
  const rtl = useGcsStore((state) => state.rtl);
  const vehicleLabel = getShortVehicleId(vehicleId);

  const onConfirmClicked = async () => {
    try {
      setRtlAction(AsyncAction.loading());
      await rtl(gcsId, missionId);
      setRtlAction(AsyncAction.success(undefined));
      onClose();
    } catch (error) {
      setRtlAction(AsyncAction.failure(error));
    }
  };

  return (
    <Dialog
      title={en.confirmRtlDialog.title}
      onClose={onClose}
      primaryButtonProps={{
        text: en.confirmRtlDialog.rtlButton,
        callback: onConfirmClicked,
        isLoading: rtlAction.isLoading,
        backgroundColor: 'var(--color-danger)',
        foregroundColor: '#ffffff'
      }}
      errorText={rtlAction.isFailure ? getLocalizedErrorMessage(rtlAction.error) : undefined}
    >
      <div style={{ width: 'var(--dialog-common-width)' }}>
        <Text variant='body1'>{en.confirmRtlDialog.body.replace('{vehicle}', vehicleLabel)}</Text>
      </div>
    </Dialog>
  );
}

export default ConfirmRtlDialog;
